/**
 * "A sender just changed" — said by Settings → Sending accounts, heard by anything
 * else on screen that lists senders.
 *
 * Settings opens as a dialog over the campaign, and both keep their own copy of the
 * sender list. The campaign only re-read its copy when the dialog closed — but a
 * mailbox is paired by the provider's callback, which can land seconds after the
 * dialog is gone. The campaign's account picker then went on showing "Connect mailbox"
 * for a mailbox Settings showed as connected.
 *
 * A window event rather than shared state: the two lists are fetched with different
 * scopes on purpose (see getSenderIdentities), and all the listener needs to know is
 * that its copy is out of date.
 */
export const SENDERS_CHANGED_EVENT = 'ld:senders-changed';

export function announceSendersChanged(): void {
  window.dispatchEvent(new Event(SENDERS_CHANGED_EVENT));
}
